import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormControl, Button, Accordion } from "react-bootstrap";
import "./_aiStudioToolbar.scss";

export default class AIStudioToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatInput: "",
      transcripts: {}, // Mock transcripts for each audio
    };
  }

  componentDidMount() {
    // Generate mock transcripts for existing audio files
    this.generateMockTranscripts();
  }

  componentDidUpdate(prevProps) {
    // Update transcripts when soundList changes
    if (prevProps.soundList !== this.props.soundList) {
      this.generateMockTranscripts();
    }
  }

  // Generate mock transcripts for audio files
  generateMockTranscripts() {
    const { soundList } = this.props;
    if (!soundList || soundList.length === 0) return;

    const mockTranscripts = {};
    const sampleTexts = [
      "Welcome to our learning platform. This section introduces the key concepts we will explore.",
      "In this chapter, we dive deeper into the core principles and methodologies.",
      "Now lets practice what we have learned with this interactive exercise.",
      "Here is a summary of the key points covered in this lesson.",
      "This audio explains the fundamental theories behind our approach.",
      "Listen carefully as we describe the step-by-step process.",
      "This segment covers advanced techniques and best practices.",
      "We conclude with practical applications and real-world examples.",
    ];

    soundList.forEach((sound, index) => {
      mockTranscripts[sound.id || index] = {
        text: sampleTexts[index % sampleTexts.length],
        sceneName: sound.name || `Scene ${index + 1}`,
        duration: this.formatDuration(sound.endTime - sound.startTime),
      };
    });

    this.setState({ transcripts: mockTranscripts });
  }

  formatDuration(seconds) {
    if (!seconds || seconds <= 0) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  handleChatInputChange = (e) => {
    this.setState({ chatInput: e.target.value });
  };

  handleChatSubmit = () => {
    const { chatInput } = this.state;
    if (chatInput.trim()) {
      // Here you would typically send the message to your AI service
      if (this.props.onChatSubmit) {
        this.props.onChatSubmit(chatInput);
      }
      this.setState({ chatInput: "" });
    }
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleChatSubmit();
    }
  };

  handleRegenerateAudio = (soundId) => {
    // Add regeneration logic here
  };

  handleEditTranscript = (soundId) => {
    // Add edit logic here
  };

  render() {
    const { open, onClose, soundList } = this.props;
    const { chatInput, transcripts } = this.state;

    // Filter sounds for current scene/page
    const sceneSounds = soundList || [];

    if (!open) {
      return null;
    }

    return (
      <div
        id="aiStudioWrap"
        className="wrapper"
        style={{
          right: "0px",
          top: "110px", // Adjusted to match toolbar position,
        }}
      >
        <div className="pestana" id="aiStudioFlap" onClick={onClose} />
        <div
          id="aiStudioTools"
          style={{
            width: "250px",
          }}
          className="toolbox toolsSpread"
        >
          <div onClick={onClose} className="carouselListTitle toolbarSpread">
            <div className="toolbarTitle">
              <i id="wheel" className="material-icons">
                edit
              </i>
              <span className="toolbarTitletxt">AI Studio</span>
            </div>
            <div className="pluginTitleInToolbar">AI Assistant</div>
          </div>

          <div id="insidetools">
            <div className="toolbarTabs">
              {/* Chat Input Section */}
              <Accordion className="panelPluginToolbar">
                <Accordion.Item eventKey="0" className="panelPluginToolbar">
                  <Accordion.Header>
                    <div className="titleA">
                      <i className="material-icons">chat</i>
                      AI Chat Assistant
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <FormControl
                        as="textarea"
                        rows={2}
                        placeholder="Ask AI to help with your content..."
                        value={chatInput}
                        onChange={this.handleChatInputChange}
                        onKeyDown={this.handleKeyDown}
                        style={{
                          resize: "vertical",
                          minHeight: "60px",
                          maxHeight: "150px",
                        }}
                      />
                      <Button
                        className="toolbarButton"
                        onClick={this.handleChatSubmit}
                        disabled={!chatInput.trim()}
                        style={{
                          alignSelf: "flex-end",
                          width: "auto",
                          minWidth: "44px",
                          padding: "8px 12px",
                        }}
                      >
                        <i className="material-icons" style={{ fontSize: "18px" }}>
                          send
                        </i>
                      </Button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* Scene Audio Section */}
              <Accordion className="panelPluginToolbar">
                <Accordion.Item eventKey="0" className="panelPluginToolbar">
                  <Accordion.Header>
                    <div className="titleA">
                      <i className="material-icons">audiotrack</i>
                      AI Generated Audio
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {sceneSounds.length > 0 ? (
                      <Accordion>
                        {sceneSounds.map((sound, index) => {
                          const soundId = sound.id || index;
                          const transcript = transcripts[soundId] || {};

                          return (
                            <Accordion.Item key={soundId} eventKey={String(index)}>
                              <Accordion.Header>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "500",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <i
                                      className="material-icons"
                                      style={{
                                        fontSize: "16px",
                                        marginRight: "8px",
                                      }}
                                    >
                                      audiotrack
                                    </i>
                                    {transcript.sceneName || sound.name || `Audio ${index + 1}`}
                                  </span>
                                  <span
                                    style={{ fontSize: "12px", color: "#666", marginRight: "10px" }}
                                  >
                                    {transcript.duration || "0:00"}
                                  </span>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                                {sound.url && (
                                  <audio
                                    controls
                                    style={{
                                      width: "100%",
                                      marginBottom: "10px",
                                    }}
                                    src={sound.url}
                                  >
                                    Your browser does not support the audio element.
                                  </audio>
                                )}
                                <div
                                  style={{
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    padding: "12px",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    lineHeight: "1.5",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <strong>Transcript:</strong>
                                  <p style={{ margin: "8px 0 0 0", color: "#ccc" }}>
                                    {transcript.text || "No transcript available for this audio."}
                                  </p>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                      </Accordion>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px 20px",
                          color: "#999",
                          backgroundColor: "rgba(255, 255, 255, 0.05)",
                          borderRadius: "4px",
                        }}
                      >
                        <i
                          className="material-icons"
                          style={{ fontSize: "48px", color: "#666", marginBottom: "10px" }}
                        >
                          mic_off
                        </i>
                        <p>No AI generated audio available for this scene.</p>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AIStudioToolbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  soundList: PropTypes.array,
  navItemSelected: PropTypes.any,
  onChatSubmit: PropTypes.func,
};
